import React from 'react';

const Groups: React.FC = () => {
    return(
        <p>groups</p>
    )
};

export default Groups;